// extracted by mini-css-extract-plugin
module.exports = {"tag":"styles_tag__s36A5","title":"styles_title__gqs5r","wrapper":"styles_wrapper__nz0Q2","date":"styles_date__51axo"};